import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { useSingleEmailComposer, useUserSession } from '../../../../../models/hooks/appStateHooks';
import { Button } from '../../../../components-v2/Button';
import { DrawerClose, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle } from '../../../../components-v2/Drawer';
import { white } from '../../../../styles/colors';
import { styleSheet as flyoutStyleSheet } from '../../styles';
import { EntityChip } from '../../../chips/EntityChip';
import { EmailIcon } from '../../../svgs/icons/EmailIcon';
import { styleSheet } from './styles';
import { Separator } from '../../../Separator';

export const MatterDetailsFlyout = ({ matter }: { matter: Api.ILegalMatter }) => {
	const userSession = useUserSession();
	const singleEmailComposer = useSingleEmailComposer();

	const formatDate = (dateString?: string) => {
		if (!dateString) return '-';
		return moment(dateString).format('MM/DD/YYYY');
	};

	const sendEmail = () => {
		if (matter.contact) {
			const contactVm = new Api.ContactViewModel(userSession, matter.contact);
			singleEmailComposer.showForRecipients([contactVm]);
		}
	};

	return (
		<DrawerContent>
			<DrawerHeader>
				<DrawerTitle>Matter Details</DrawerTitle>
			</DrawerHeader>
			<div className={css(flyoutStyleSheet.flyoutBody)}>
				<div className={css(styleSheet.container)}>
					<section className={css(styleSheet.section)}>
						<h4 className={css(flyoutStyleSheet.subTitle)}>{matter.matterName}</h4>
						{matter.matterNumber ? <small>#{matter.matterNumber}</small> : null}
					</section>

					{matter.contact ? (
						<section className={css(styleSheet.section)}>
							<span className={css(styleSheet.label)}>Contact</span>
							<EntityChip
								entity={new Api.ContactViewModel(userSession, matter.contact)}
								readOnly={true}
								sizeConstraint='compact'
							/>
						</section>
					) : null}

					{matter.contact?.primaryEmail?.value ? (
						<section className={css(styleSheet.quickActions)}>
							<a className={css(styleSheet.quickActionButton)} onClick={sendEmail}>
								<EmailIcon fillColor={white} width={16} height={14} />
							</a>
						</section>
					) : null}

					<Separator />

					<section className={css(styleSheet.detailsSection)}>
						<div className={css(styleSheet.detailRow)}>
							<span className={css(styleSheet.label)}>Stage</span>
							<span className={css(styleSheet.value)}>{matter.stage?.name || '-'}</span>
						</div>

						<div className={css(styleSheet.detailRow)}>
							<span className={css(styleSheet.label)}>Status</span>
							<span className={css(styleSheet.value)}>{matter.status?.name || '-'}</span>
						</div>

						<div className={css(styleSheet.detailRow)}>
							<span className={css(styleSheet.label)}>Practice Area</span>
							<span className={css(styleSheet.value)}>{matter.practiceArea?.name || '-'}</span>
						</div>

						<div className={css(styleSheet.detailRow)}>
							<span className={css(styleSheet.label)}>Open Date</span>
							<span className={css(styleSheet.value)}>{formatDate(matter.openDate)}</span>
						</div>

						<div className={css(styleSheet.detailRow)}>
							<span className={css(styleSheet.label)}>Close Date</span>
							<span className={css(styleSheet.value)}>{formatDate(matter.closeDate)}</span>
						</div>
					</section>
				</div>
			</div>
			<DrawerFooter>
				<DrawerClose
					render={props => (
						<Button variant='secondary' {...props}>
							Close
						</Button>
					)}
				/>
			</DrawerFooter>
		</DrawerContent>
	);
};
